module.exports = __webpack_public_path__ + "img/复活节兔子灯-3.3f1afc49.jpg";